var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C9.72501 16 9.48959 15.8922 9.29375 15.6765C9.09792 15.4609 9 15.2017 9 14.8988C9 14.596 9.09792 14.3368 9.29375 14.1211C9.48959 13.9055 9.72501 13.7977 10 13.7977C10.275 13.7977 10.5104 13.9055 10.7062 14.1211C10.9021 14.3368 11 14.596 11 14.8988C11 15.2017 10.9021 15.4609 10.7062 15.6765C10.5104 15.8922 10.275 16 10 16ZM9.08975 12.4V4H10.9102V12.4H9.08975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.1bf577ff980dbb7b3ba95d611d728fb8.svg";
export { ForwardRef as ReactComponent };